var _rect, _line, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlignBottom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    id: "align-bottom",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 256,
    fill: "none"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 216.005,
    x2: 40.005,
    y1: 216.006,
    y2: 216.006,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 24
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 104,
    height: 52,
    x: 122,
    y: 98,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 24,
    rx: 8,
    transform: "rotate(-90 174 124)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 144,
    x: 56,
    y: 32,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 24,
    rx: 8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlignBottom);
export default __webpack_public_path__ + "static/media/align-bottom.aedce23e8b7ecd62fc00fc7234286296.svg";
export { ForwardRef as ReactComponent };